//this page is dedicated to the tax payers, where they can access their account and manage their information, such as their name, email, password, and address. They can also view their order history and track their current orders. The page should have a simple and intuitive design, with clear navigation and easy access to all the features. The tax payers should be able to update their information and manage their orders with ease, ensuring a smooth and efficient user experience.

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { encryptPassword, decryptPassword, encryptString, decryptString } from '../utils/crypto';
import { CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

function TaxPayer() {
    const idTaxPayer = 0;
    const guidTaxPayer = useParams().id;
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [taxPayer, setTaxPayer] = useState({
        IdTaxPayer: 0,
        txpFullName: '',
        txpDateOfBirth: '',
        txpFullAddress: '',
        txpCity: '',
        txpState: '',
        txpZipCode: '',
        txpCellPhone: '',
        txpOccupation: '',
        txpEmail: '',
        txpSSN: '',
        txpITIN: '',
        txpPassword: '',
        txpDL: '',
        txpSSC: '',
        txpSpouseFullName: '',
        txpSpouseDateOfBirth: '',
        txpSpouseCellPhone: '',
        txpSpouseOccupation: '',
        txpSpouseEmail: '',
        txpSpouseSSN: '',
        txpSpouseSSC: '',
        txpD1FullName: '',
        txpD1DateOfBirth: '',
        txpD1Relationship: '',
        txpD2FullName: '',
        txpD2DateOfBirth: '',
        txpD2Relationship: '',
        txpD3FullName: '',
        txpD3DateOfBirth: '',
        txpD3Relationship: '',
        txpD4FullName: '',
        txpD4DateOfBirth: '',
        txpD4Relationship: '',
        txpCreatedIn: new Date().toISOString(),
        txpCreatedBy: '',
        txpUpdatedIn: new Date().toISOString(),
        txpUpdatedBy: '',
        txpCodeGUID: uuidv4(),
        txpStatus: 1
    });

    const [requestsHistory, setRequestsHistory] = useState([]);

    //get tax payer data by id
    useEffect(() => {
        if(guidTaxPayer && guidTaxPayer !== '') {
            setIsLoading(true);
            const dataToSend = { txpCodeGUID: guidTaxPayer };
            axios
            .post(process.env.REACT_APP_API_URL + `/routes.php?method=getTaxPayerByCodeGUID`,
                dataToSend,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                //console.log('Tax payer data:', response.data);
                if(response.data && parseInt(response.data.IdTaxPayer) > 0) {
                    setTaxPayer(response.data);
                    //console.log('Tax payer data:', response.data);
                }
                setIsLoading(false);
            })
            .catch(error => {
                if(error.response && error.response.data && error.response.data.Message) {
                    alert(error.response.data.Message);
                } else {
                    alert('An error occurred while fetching the tax payer.');
                }
                setIsLoading(false);
            });
        }
    }, [guidTaxPayer]);
    //get tax return request history by tax payer id
    useEffect(() => {
        if(guidTaxPayer && guidTaxPayer !== '') {
            setIsLoading(true);
            const dataToSend2 = { txpCodeGUID: guidTaxPayer };
            axios
            .post(process.env.REACT_APP_API_URL + `/routes.php?method=getRequestsPayerCodeGUID`,
                dataToSend2,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                if(response.data && response.data[0].IdRequest) {
                    // Here you can add the logic to handle the response from the backend API and display the tax return request history in the table
                    //console.log('Tax return request history:: ', response.data);
                    setRequestsHistory(response.data);
                } else if (response.Message) {
                    alert(response.Message);
                     setRequestsHistory([]);
                }
                 else {
                    setRequestsHistory([]);
                }
                setIsLoading(false);
            })
            .catch(error => {
                if(error.response && error.response.data && error.response.data.Message) {
                    alert(error.response.data.Message);
                } else {
                    alert('An error occurred while fetching the tax return request history. ' + error);
                }
                setIsLoading(false);
            });
        }
    }, [guidTaxPayer]);
    //function get tax return request history by tax payer id.
    function getRequestsHistory() {
        if(guidTaxPayer && guidTaxPayer !== '') {
            setIsLoading(true);
            const dataToSend2 = { txpCodeGUID: guidTaxPayer, };
            axios
            .post(process.env.REACT_APP_API_URL + `/routes.php?method=getRequestsPayerCodeGUID`,
                dataToSend2,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                if(response.data && response.data[0].IdRequest) {
                    // Here you can add the logic to handle the response from the backend API and display the tax return request history in the table
                    console.log('Tax return request history:: ', response.data);
                    setRequestsHistory(response.data);
                } else if (response.Message) {
                    alert(response.Message);
                     setRequestsHistory([]);
                }
                 else {
                    setRequestsHistory([]);
                }
                setIsLoading(false);
            })
            .catch(error => {
                if(error.response && error.response.data && error.response.data.Message) {
                    alert(error.response.data.Message);
                } else {
                    alert('An error occurred while fetching the tax return request history. ' + error);
                }
                setIsLoading(false);
            });
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTaxPayer({ ...taxPayer, [name]: value });
    }
    
    const handleNewRequest = (e) => {
        e.preventDefault();
        const dataToSend = {
            IdRequest: 0,
            IdTaxPayer: taxPayer.IdTaxPayer,
            reqYear: new Date().getFullYear(),
        };
        //console.log('Data to send for new request: ', dataToSend);
        axios
        .post(process.env.REACT_APP_API_URL + `/routes.php?method=getRequests`,
            dataToSend,
            { headers: {
                'X-Access-Token' : tokenAPI,
                'Content-Type': 'application/json; charset=UTF-8'
            }
            })
        .then(response => {
            if(response.data && response.data[0].IdRequest) {
                // Here you can add the logic to handle the response from the backend API and display the tax return request history in the table
                console.log('Tax return request history:: ', response.data);
                alert('Your tax return for this year has already been requested! You will receive an email notification once your request has been updated.');
                //alert('Your tax return request has been created successfully! Please allow up to 10 business days for processing. You will receive an email notification once your request has been completed.');
            } else if (response.data.Message) {
                alert('A new request has been created for this year!');
                //criar uma nova solicitação
                const dataToSend2 = {
                    IdRequest: 0,
                    IdTaxPayer: taxPayer.IdTaxPayer,
                    reqYear: new Date().getFullYear(),
                    reqStatus: 0,
                    reqObservations: 'Request created, waiting for analysis.',
                    reqCreatedIn: new Date().toISOString(),
                    reqCreatedBy: taxPayer.txpFullName,
                    reqUpdatedIn: new Date().toISOString(),
                    reqUpdatedBy: taxPayer.txpFullName,
                    reqCodeGUID: uuidv4(),
                };
                axios
                .post(process.env.REACT_APP_API_URL + `/routes.php?method=createRequest`,
                    dataToSend2,
                    { headers: {
                        'X-Access-Token' : tokenAPI,
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                    })
                .then(response => {
                    if(response.data && response.data.IdRequest) {
                        alert('Your tax return request has been created successfully! Please allow up to 10 business days for processing. You will receive an email notification once your request has been completed.');
                        // Here you can add the logic to handle the response from the backend API and display the tax return request history in the table
                        console.log('New tax return request created:: ', response.data);
                        getRequestsHistory();
                    } else if (response.data.Message) {
                        alert(response.data.Message);
                    } else {
                        alert('An error occurred while creating the tax return request. Please try again later.');
                    }
                })
                .catch(error => {
                    if(error.data && error.data.Message) {
                        alert(error.data.Message);
                    } else {
                        alert('An error occurred while creating the tax return request. ' + error);
                    }
                });
            }
             else {
                alert('elsee finally : ' + JSON.stringify(response.data));
            }
        })
        .catch(error => {
            if(error.data && error.data[0].Message) {
                alert(error.data[0].Message);
            } else {
                alert('An error occurred while fetching the tax return request history. ' + error);
            }
        });
    }

    const handleDocuments = (request) => {
        navigate('/documents/' + request.reqCodeGUID);
    }

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div>
                        <label>Welcome {decryptString(taxPayer.txpFullName)}.</label>
                    </div>
                    <div>
                        <label className='labelContent'>Here you can manage your account information and view your order history.</label>
                    </div>
                </div>
                <div className='tabelaPadrao'>
                    <table className='tabelaDados'>
                        <thead>
                            <tr>
                                <th className='tdAlignLeft'>Full Name</th>
                                <th className='tdAlignLeft'>Date of Birth</th>
                                <th className='tdAlignLeft'>Email</th>
                                <th className='tdAlignLeft'>Cell Phone</th>
                                <th className='tdAlignLeft'>Occupation</th>
                                <th className='tdAlignLeft'>City/State</th>
                                <th className='tdAlignLeft'>SSN</th>
                                <th className='tdAlignLeft'>DL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            ) : (
                                <tr onClick={() => navigate('/Register/' + taxPayer.txpCodeGUID)} style={{ cursor: 'pointer' }}>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpFullName)}</td>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpDateOfBirth)}</td>
                                    <td className='tdAlignLeft Lowercase'>{taxPayer.txpEmail}</td>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpCellPhone)}</td>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpOccupation)}</td>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpCity)}/{decryptString(taxPayer.txpState)}</td>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpSSN)}</td>
                                    <td className='tdAlignLeft Uppercase'>{decryptString(taxPayer.txpDL)}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className='headerMain'>
                    <div>
                        <label>Your tax return request.</label>
                    </div>
                    <div>
                        <label className='labelContent'>Here you can view your tax return request history.</label>
                    </div>
                </div>
                <div className='text-align-right mb1 fs14 w100'>
                    <button 
                        className='buttonModalPadraoCinza p1 fs12' onClick={handleNewRequest}
                        style={{ textDecoration: 'none', cursor: 'pointer' }}>
                        Request a tax return
                    </button>
                </div>
                <div className='tabelaPadrao'>
                    <table className='tabelaDados'>
                        <thead>
                            <tr>
                                <th className='tdAlignLeft'>Tax Return Year</th>
                                <th className='tdAlignLeft'>Status</th>
                                <th className='tdAlignLeft'>Created In</th>
                                <th className='tdAlignLeft'>Updated In</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Here you can map through the tax return request history and display the data in the table */}
                            {isLoading ? (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            ) : (
                                requestsHistory.length > 0 ? (
                                    requestsHistory.map((request) => (
                                        <tr key={request.IdRequest} onClick={() => handleDocuments(request)} style={{ cursor: 'pointer' }}>
                                            <td className='tdAlignLeft Uppercase'>{request.reqYear}</td>
                                            <td className='tdAlignLeft Uppercase'>{parseInt(request.reqStatus) === 1 ? 'In Progress' : parseInt(request.reqStatus) === 2 ? 'Completed' : 'In Analysis'}</td>
                                            <td className='tdAlignLeft Uppercase'>{new Date(request.reqCreatedIn).toISOString().split('T')[0]}</td>
                                            <td className='tdAlignLeft Uppercase'>{new Date(request.reqUpdatedIn).toISOString().split('T')[0]}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" style={{ textAlign: 'center' }}>
                                            No tax return requests found.
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </main>
        </div>
    );
}

export default TaxPayer;